import React, {FC, useMemo} from 'react';
import './style.scss';

interface StepperProps {
  steps: number,
  currentStep: number
}

export const Stepper: FC<StepperProps> = ({steps, currentStep}) => {

  const stepArray = useMemo(() => {
    return Array.from({length: steps}, (v, i) => i)
  }, [steps]);

  return (
    <div
      className="stepper"
    >
      {stepArray.map(step => {
        let className = "circle-step";
        if (step === currentStep) className += " active";
        return (<div className={className} key={step}/>);
      })}
    </div>
  );
}
